import { useState } from "react";
import { useParams, Link } from "react-router";
import { IconArrowLeft } from "@tabler/icons-react";
import { useAuditLog } from "@/api/hooks";
import { ActivityLog } from "@/components/activity-log";
import { Skeleton } from "@/components/ui/skeleton";
import { asBuildId, asEventId } from "@/types/identifiers";

export function AuditLogPage() {
  const { buildId: rawBuildId, eventId: rawEventId } = useParams();
  const buildId = rawBuildId ? asBuildId(rawBuildId) : undefined;
  const eventId = rawEventId ? asEventId(rawEventId) : undefined;
  const [beforeId, setBeforeId] = useState<string | undefined>();
  const { data, isLoading } = useAuditLog(buildId!, beforeId);

  if (!buildId || !eventId) return null;

  const items = data?.items ?? [];
  const hasMore = data?.has_more ?? false;

  return (
    <div>
      <Link
        to={`/events/${eventId}/builds/${buildId}`}
        className="text-[13px] text-muted-foreground hover:text-foreground inline-flex items-center gap-1"
      >
        <IconArrowLeft className="h-3.5 w-3.5" />
        Back to Build
      </Link>

      <h1 className="text-lg font-semibold mt-4 mb-4">Audit Log</h1>

      {isLoading && items.length === 0 ? (
        <div className="space-y-4">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-32 w-full rounded-lg" />
        </div>
      ) : items.length === 0 ? (
        <p className="text-sm text-muted-foreground">No audit entries yet.</p>
      ) : (
        <ActivityLog items={items} />
      )}

      {hasMore && (
        <div className="mt-4 flex justify-center">
          <button
            onClick={() => setBeforeId(items[items.length - 1]?.id)}
            className="px-4 py-2 text-sm border rounded-md hover:bg-muted"
          >
            Load more
          </button>
        </div>
      )}

      {isLoading && items.length > 0 && (
        <div className="text-center py-4 text-muted-foreground text-sm">Loading…</div>
      )}
    </div>
  );
}
